import { Link } from 'react-router-dom'
import { IMenu } from '../../../../types/menu'

interface Props {
	subMenu: IMenu
}
export function SubMenu({ subMenu }: Props) {

	return (
		<div className="mb-4 last:mb-0">
			<div className="px-3 mb-2 font-bold text-[0.625rem] uppercase tracking-widest text-on-surface-subtle dark:text-on-surface-dark-muted border-l-2 border-secondary ml-px">
				{subMenu.titulo}
			</div>

			<div className="flex flex-col gap-0.5">
				{subMenu.subMenus?.map((item: IMenu, index: number) => {
					let subMenu_link = '#'
					let isInternal = false

					if (item.ref_cod_artigo && [2, 11, 14].includes(item.ref_cod_menu_tipo_componente ?? 0)) {
						subMenu_link = '/a/' + item.ref_cod_artigo
						isInternal = true
					} else if (item.ref_cod_entidade && [15, 19].includes(item.ref_cod_menu_tipo_componente ?? 0)) {
						subMenu_link = '/e/' + item.ref_cod_entidade
						isInternal = true
					} else if (item.link) {
						subMenu_link = item.link
					}

					let subMenu_target = item.nova_janela ? '_blank' : '_self'

					return (
						isInternal ? (
							<Link
								key={index}
								to={subMenu_link}
								className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-1.5 rounded-lg block"
							>
								{item.titulo}
							</Link>
						) : (
							<a
								key={index}
								href={`${subMenu_link}`}
								target={`${subMenu_target}`}
								rel={subMenu_target === '_blank' ? "noreferrer" : ""}
								className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-1.5 rounded-lg block"
							>
								{item.titulo}
							</a>
						)
					)
				})}
			</div>
		</div>
	)
}